import React, { useState, useEffect } from "react"
import { jsPDF } from "jspdf"
import html2canvas from "html2canvas"
import { useToast } from "../../hooks/useToast"
import "../styles/QuoteDetails.css"

function QuoteDetails({ quote, onSave, selectedLead, hasQuote }) {
  const { notify } = useToast()
  const [localQuoteDetails, setLocalQuoteDetails] = useState({})
  const [isEditable, setIsEditable] = useState(false)

  useEffect(() => {
    if (hasQuote) {
      setLocalQuoteDetails(quote)
    } else {
      // Set up a new quote
      setLocalQuoteDetails({
        leadId: selectedLead.id,
        quoteNumber: "",
        dated: new Date().toISOString().split("T")[0],
        description: "",
        materialCost: 0,
        laborCost: 0,
        totalCost: 0,
        status: "pending",
      })
    }
  }, [quote, selectedLead, hasQuote])

  const handleEdit = () => {
    setIsEditable(!isEditable)
  }

  const handleSaveChanges = async (e) => {
    e.preventDefault()
    console.log("Saving quote details", localQuoteDetails) // Debug log

    try {
      if (!localQuoteDetails.id) {
        console.log("Creating a new quote") // Debug log
        await onSave({ ...localQuoteDetails, isNew: true })
      } else {
        console.log("Updating existing quote") // Debug log
        await onSave(localQuoteDetails)
      }
      notify("Quote Saved Successfully!", "success")
    } catch (error) {
      console.error("Error in handleSaveChanges:", error) // Error log
      notify("Error Saving Quote.", "error")
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setLocalQuoteDetails((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      await onSave(localQuoteDetails)
      notify("Quote Saved Successfully!", "success")
    } catch (error) {
      notify("Error Saving Quote.", "error")
    }
  }

  const exportToPDF = async () => {
    const pdf = new jsPDF()
    const quoteDetailsElement = document.querySelector(
      ".quoteDetails-container"
    )
    const canvas = await html2canvas(quoteDetailsElement)
    pdf.addImage(canvas.toDataURL(), "PNG", 0, 0)
    pdf.save("QuoteDetails.pdf")
  }

  return (
    <div className="quoteDetails-container">
      <h2 className="quoteDetailsHeading">Quote Details</h2>
      <form className="quoteDetailsCard" onSubmit={handleSaveChanges}>
        <div className="quoteDetailsCardBody">
          <label>
            <strong>LeadId:</strong>
            <textarea
              name="leadId"
              value={localQuoteDetails.leadId || ""}
              onChange={handleChange}
              disabled={!isEditable}
            />
          </label>
          <label>
            <strong>Quote Number:</strong>
            <input
              type="text"
              name="quoteNumber"
              value={localQuoteDetails.quoteNumber || ""}
              onChange={handleChange}
              disabled={!isEditable}
            />
          </label>
          <label>
            <strong>Date:</strong>
            <input
              type="date"
              name="dated"
              value={localQuoteDetails.dated || ""}
              onChange={handleChange}
              disabled={!isEditable}
            />
          </label>
          <label>
            <strong>Description:</strong>
            <textarea
              name="description"
              value={localQuoteDetails.description || ""}
              onChange={handleChange}
              disabled={!isEditable}
            />
          </label>
          <label>
            <strong>Material Cost:</strong>
            <input
              type="number"
              name="materialCost"
              value={localQuoteDetails.materialCost || 0}
              onChange={handleChange}
              disabled={!isEditable}
            />
          </label>
          <label>
            <strong>Labor Cost:</strong>
            <input
              type="number"
              name="laborCost"
              value={localQuoteDetails.laborCost || 0}
              onChange={handleChange}
              disabled={!isEditable}
            />
          </label>
          <label>
            <strong>Total Cost:</strong>
            <input
              type="number"
              name="totalCost"
              value={localQuoteDetails.totalCost || 0}
              onChange={handleChange}
              disabled={!isEditable}
            />
          </label>
          <label>
            <strong>Status:</strong>
            <select
              name="status"
              value={localQuoteDetails.status || ""}
              onChange={handleChange}
              disabled={!isEditable}
            >
              <option value="pending">Pending</option>
              <option value="approved">Approved</option>
              <option value="rejected">Rejected</option>
            </select>
          </label>
        </div>
        <div className="quoteDetailsActions">
          {isEditable ? (
            <>
              <button type="submit">Save Changes</button>
              <button type="button" onClick={() => setIsEditable(false)}>
                Cancel
              </button>
            </>
          ) : (
            <button type="button" onClick={handleEdit}>
              Edit
            </button>
          )}
          <button type="button" onClick={exportToPDF}>
            Export to PDF
          </button>
        </div>
      </form>
    </div>
  )
}

export default QuoteDetails
